<div style="text-align: center;">
  <svg-icon
    src="assets/logos/spinner.svg"
    [svgStyle]="{
      'max-width.rem': 2.5
    }"
  ></svg-icon>
</div>
